
document.addEventListener("DOMContentLoaded", ()=> {

	var slideShows_a = document.querySelectorAll(".slideShow");
	
	var storedAvailableLang = localStorage.getItem("availableLang");
//console.log("storedAvailableLang = " + storedAvailableLang);
	var availableLang_a = JSON.parse(storedAvailableLang);
	
	var currentLang = localStorage.getItem("langSelected");
	var [currLangAcron, currLangInd] = getLangProperties(currentLang);
	
	const productSlideShow = [];
		
//console.log("availableLang_a = " + availableLang_a);
		
	slideShows_a.forEach( (sldShw, ind) => {
		
		var slideShowName = sldShw.getAttribute("name");
		
		productSlideShow[ind] = new slideShow(`.slideShow_content_${slideShowName}`);
		
		var slideShowCfg = globalThis.SiteApp[`${slideShowName}_Cfg`];
		productSlideShow[ind].slidesAutoPlay = slideShowCfg.slideShowAutoPlay;
		productSlideShow[ind].slidesType_bPush1Fade0 = slideShowCfg.slideShowType_bPush1Fade0;
		productSlideShow[ind].slideShowZoomIn = slideShowCfg.slideShowZoomIn;
console.log("productSlideShow[ind].slideShowZoomIn = " + productSlideShow[ind].slideShowZoomIn);
		productSlideShow[ind].numberOfSlides2Display = slideShowCfg.numPushSlides2Display;

	availableLang_a.forEach( (lang) => {
		
		let [langAcron, langInd] = getLangProperties(lang);
		
		for ( const slide of productSlideShow[ind].slideShowDomEl.querySelectorAll(`.slideBox_${slideShowName}__slide`) )
			{
// for each slideShow object select the HTML elements containing the relevant slides, add them as a property of the slideShow object
// and attach a 'click' listener to each slide
				if ( slide.classList.contains(`slideBox__slide_lang_${langAcron}`) /* && (slide.children.length !== 0) */ )
					{
						productSlideShow[ind][`slides_${langAcron}`].push(slide);
console.log(slide);	
						slide.addEventListener('click', ()=> {
							productSlideShow[ind].mouseDwnPrev = true;
						})
					}
			}
console.log(`productSlideShow[ind][slides_${langAcron}] = ` + productSlideShow[ind][`slides_${langAcron}`]);
	});

// add a 'click' listener to each "previous button" of each slideShow object for: 
// a) setting the slideShow flag "mouseDwnPrev" --> will stop the slideShow animation	
// b) passing the "moveBackOnClick" call-back --> will move the Slideshow 1 slide backwards on click event
// c) passing the "darkerPrev" call-back --> will color the button with a darker color on mouse-up event 
// d) passing the "lighterPrev" call-back --> will color the button with a lighter color on mouse-down event 

	availableLang_a.forEach( (lang) => {
			
		let [langAcronUponEv, langIndUponEv] = getLangProperties(lang);
		
		for ( let buttonPrevEl of productSlideShow[ind].slideShowDomEl.querySelectorAll(`.slideShow__button_previous`) )
			{
console.log(buttonPrevEl);	
			if (buttonPrevEl.getAttribute('lang')===`${langAcronUponEv}`)
				{
					productSlideShow[ind][`buttonPrevDomEl_${langAcronUponEv}`] = buttonPrevEl; 
//console.log(`productSlideShow[ind][buttonPrevDomEl_${langAcronUponEv}] = ` + productSlideShow[ind][`buttonPrevDomEl_${langAcronUponEv}`]);					
					buttonPrevEl.addEventListener('click', ()=> {
						productSlideShow[ind].mouseDwnPrev = true;
						productSlideShow[ind].moveBackOnClick(`${langAcronUponEv}`);
					})
					
					buttonPrevEl.addEventListener('mouseup', ()=> {
						productSlideShow[ind].darkerPrev(`${langAcronUponEv}`);
					})
					
					buttonPrevEl.addEventListener('mousedown', ()=> {
						productSlideShow[ind].lighterPrev(`${langAcronUponEv}`);
					})
				}
			}
console.log(`productSlideShow[ind][buttonPrevDomEl_${langAcronUponEv}] = ` + productSlideShow[ind][`buttonPrevDomEl_${langAcronUponEv}`]);		
	});

// add a 'click' listener to each "next button" of each slideShow object for: 
// a) setting the slideShow flag "mouseDwnPrev" --> will stop the slideShow animation	
// b) passing the "moveFwdOnClick" call-back --> will move the Slideshow 1 slide forwards on click event
// c) passing the "darkerNext" call-back --> will color the button with a darker color on mouse-up event 
// d) passing the "lighterNext" call-back --> will color the button with a lighter color on mouse-down event 

	availableLang_a.forEach( (lang) => {
				
		let [langAcronUponEv, langIndUponEv] = getLangProperties(lang);
		
		for ( let buttonNextEl of productSlideShow[ind].slideShowDomEl.querySelectorAll(`.slideShow__button_next`) )
			{
//console.log(buttonNextEl);	
			if (buttonNextEl.getAttribute('lang')===`${langAcronUponEv}`)
				{
					productSlideShow[ind][`buttonNextDomEl_${langAcronUponEv}`] = buttonNextEl; 
					
					buttonNextEl.addEventListener('click', (ev)=> {
						productSlideShow[ind].mouseDwnPrev = true;
//console.log("ev.target = " + ev.target.outerHTML);
console.log("langAcron = " + `${langAcronUponEv}`);
						productSlideShow[ind].moveFwdOnClick(`${langAcronUponEv}`);
					})
					
					buttonNextEl.addEventListener('mouseup', ()=> {
						productSlideShow[ind].darkerNext(`${langAcronUponEv}`);
					})
					
					buttonNextEl.addEventListener('mousedown', ()=> {
						productSlideShow[ind].lighterNext(`${langAcronUponEv}`);
					})
				}
			}
console.log(`productSlideShow[ind][buttonNextDomEl_${langAcronUponEv}] = ` + productSlideShow[ind][`buttonNextDomEl_${langAcronUponEv}`]);	
	});
	
	
		screen.orientation.addEventListener('change', () => {
	
			if (window.matchMedia("(orientation: landscape)").matches)
				{
// the zoom-in of the slideShow box size is reset when the screen is toggled to 'landscape' orientation
					if (productSlideShow[ind].createdStyle4SlideZoomIn === true)
						{
						productSlideShow[ind].styleDomEl.remove();
						productSlideShow[ind].createdStyle4SlideZoomIn = false;
						}
				}
		});
console.log(currLangAcron);
		productSlideShow[ind].init(currLangAcron);
		
	});
	
//console.log("productSlideShow[0] = " + productSlideShow[0].slideShowDomEl.innerHTML);
//console.log("productSlideShow[1] = " + productSlideShow[1].slideShowDomEl.innerHTML);
//console.log("productSlideShow[0].slides_it = " + productSlideShow[0].slides_it[1].outerHTML);
//console.log("productSlideShow[0].slides_en = " + productSlideShow[0].slides_en[1].outerHTML);
//console.log("productSlideShow[1].slides_it = " + productSlideShow[1].slides_it[1].outerHTML);
//console.log("productSlideShow[1].slides_en = " + productSlideShow[1].slides_en[1].outerHTML);
	
	SiteApp.eventBus.on("language:change", (currentLang)=> {
		
		var [currLangAcron, currLangInd] = getLangProperties(currentLang);
		
		slideShows_a.forEach( (sldShw, ind) => {
			
			var slideShowName = sldShw.getAttribute("name");
console.log(currLangAcron);			
			productSlideShow[ind].init(currLangAcron);
		});
	});
	
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////// CLASSES DEFINITIONS /////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class slideShow {
	constructor(slideShowSelector) {
		this.slideShowDomEl = document.querySelector(slideShowSelector);
		this.buttonPrevDomEl_it = null;
		this.buttonNextDomEl_it = null;
		this.buttonPrevDomEl_en = null;
		this.buttonNextDomEl_en = null;
		this.buttonPrevDomEl_fr = null;
		this.buttonNextDomEl_fr = null;
		this.buttonPrevDomEl_de = null;
		this.buttonNextDomEl_de = null;
		this.styleDomEl = null;
		this.slideShowAnimInterval = null;
		this.mouseDwnPrev = false;
		this.mouseDwnNext = false;
		this.mouseUpPrev = false;
		this.mouseUpNext = false;
		this.createdStyle4SlideZoomIn = false;
		this.slidesAutoPlay = false;
		this.slidesType_bPush1Fade0 = false;
		this.slideShowZoomIn = false;
		this.numberOfSlides2Display = 1;
		this.slides_it = [];
		this.slides_en = [];
		this.slides_fr = [];
		this.slides_de = [];
		this.ind_slide_it = -1;
		this.ind_min_it = -1;
		this.ind_max_it = -1;
		this.ind_slide_en = -1;
		this.ind_min_en = -1;
		this.ind_max_en = -1;
		this.ind_slide_fr = -1;
		this.ind_min_fr = -1;
		this.ind_max_fr = -1;
		this.ind_slide_de = -1;
		this.ind_min_de = -1;
		this.ind_max_de = -1;
	}

//initialize push-in/push-out Slideshow		
	initPushSlideShow(langAcron) 
	{
		let ind_DispSlide = 0;
		this[`ind_slide_${langAcron}`] = ind_DispSlide;
		let slide = this[`slides_${langAcron}`];
		
		let hiddenSlide = slide[slide.length - 1];
		
		hiddenSlide.style.setProperty("transform", `translateX(${-100*slide.length}%)`);
		hiddenSlide.style.setProperty("visibility", "hidden");
	//	hiddenSlide.style.setProperty("border-style", "solid");
	//	hiddenSlide.style.setProperty("color", "red");
//console.log("hiddenSlide = " + hiddenSlide.outerHTML);
console.log("hiddenSlide = " + hiddenSlide.style);
	}

//initialize fade-in/fade-out Slideshow	
	initFadeSlideShow(langAcron) 
		{
			let ind_min = 0;
			let ind_max = ind_min + (this.numberOfSlides2Display - 1);
			let slide = this[`slides_${langAcron}`];
			
			this[`ind_min_${langAcron}`] = ind_min;
			this[`ind_max_${langAcron}`] = ind_max;
console.log(this[`ind_max_${langAcron}`]);			
			slide[slide.length-1].style.setProperty("display", "none");

console.log(slide[slide.length-1].style);
		}
		
/* ******************************************** MOVING SLIDES BWD BY FADE-IN/FADE-OUT ********************************************  */

	moveBack(langAcron) {
	
//console.log(typeof slide_bwd);
//console.log("slide_bwd = " + slide_bwd);
console.log(`this[ind_min_${langAcron}] = ` + this[`ind_min_${langAcron}`]);
console.log(`this[ind_max_${langAcron}] = ` + this[`ind_max_${langAcron}`]);

/* 	let curr_slide = slide_bwd[ind_max_bwd];

	curr_slide.style.display = "none"; */
	
	let ind_max_bwd = this[`ind_max_${langAcron}`];
	let ind_min_bwd = this[`ind_min_${langAcron}`];
	let slide_bwd = this[`slides_${langAcron}`];

	if (ind_max_bwd < slide_bwd.length-1)
		{
			ind_max_bwd += 1;
			}
	else
		{
			ind_max_bwd = 0;
			}
			
	if (ind_min_bwd < slide_bwd.length-1)
		{
			ind_min_bwd += 1;
			}
	else
		{
			ind_min_bwd = 0;
			}

/* 	let prev_slide = slide_bwd[ind_min_bwd];

	prev_slide.style.display = "flex"; */

for (let ind = 0; ind <= slide_bwd.length-1; ind++)
	{
		if ( ( (ind_min_bwd <= ind_max_bwd) && ((ind < ind_min_bwd) || (ind > ind_max_bwd)) ) || 
		( (ind_min_bwd > ind_max_bwd) && ( (ind_max_bwd < ind) && (ind < ind_min_bwd) ) ) )
			{
				slide_bwd[ind].style.display = "none";
			}
		else 
			{
				slide_bwd[ind].style.display = "flex";
				
				if ( (ind_min_bwd > ind_max_bwd) && (ind >= ind_min_bwd) )
					{
						slide_bwd[ind].style.order = "-1";
					}
				else
					{
						slide_bwd[ind].style.order = "0";
					}
			}
console.log(`style_slide_bwd[${ind}] = ` + slide_bwd[ind].style.display);
console.log(ind_max_bwd < ind < ind_min_bwd);
	}

console.log("ind_min_bwd = " + ind_min_bwd);
console.log("ind_max_bwd = " + ind_max_bwd);
console.log(ind_min_bwd > ind_max_bwd);

	this[`ind_max_${langAcron}`] = ind_max_bwd;
	this[`ind_min_${langAcron}`] = ind_min_bwd;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/* ******************************************** MOVING SLIDES BWD BY PUSH-IN/PUSH-OUT ********************************************  */

	pushBwd(langAcron) {
	
	let slide_bwd = this[`slides_${langAcron}`];
	let ind_DispSlide = this[`ind_slide_${langAcron}`];
	
	for (let ind=0; ind<slide_bwd.length; ind++)
		{
			let indSlide = slide_bwd[ind];
			
			indSlide.style.setProperty("transform",`translateX(${-100*(ind_DispSlide+1)+
			Math.min(Math.floor((slide_bwd.length-ind-1)/(slide_bwd.length-ind_DispSlide)), 1)*slide_bwd.length*100}%)`);
			
			indSlide.style.setProperty("visibility", "visible");
//			indSlide.style.setProperty("border-style", "none");
//			indSlide.style.setProperty("border-color", "none");
			indSlide.style.setProperty("transition-property", "transform");
			indSlide.style.setProperty("transition-duration", "1s");
			
				if ( (ind===ind_DispSlide-1) || ((ind_DispSlide===0) && (ind===slide_bwd.length-1)) )
					{
					indSlide.style.setProperty("visibility", "hidden");
//					indSlide.style.setProperty("border-style", "solid");
//					indSlide.style.setProperty("border-color", "red");
					}
					
	console.log(indSlide.style.getPropertyValue("transform"));
	console.log(ind);
		}
	console.log(slide_bwd.length);
	console.log(ind_DispSlide);
			
			if (ind_DispSlide < slide_bwd.length-1)
				{
					ind_DispSlide += 1;
				}
	
			else
				{
					ind_DispSlide = 0;
				} 

console.log(ind_DispSlide);

	this[`ind_slide_${langAcron}`] = ind_DispSlide;
}


/* ******************************************** MOVING SLIDES FWD BY FADE-IN/FADE-OUT ********************************************  */

	moveFwd(langAcron) {

		let ind_max_fwd = this[`ind_max_${langAcron}`];
		let ind_min_fwd = this[`ind_min_${langAcron}`];
		let slide_fwd = this[`slides_${langAcron}`];
		
		/* let curr_slide = slide_fwd[ind_min_fwd];

		curr_slide.style.display = "none"; */

		if (ind_min_fwd > 0)
			{
				ind_min_fwd -= 1;
			}

		else
			{
				ind_min_fwd = slide_fwd.length-1;
			}
		
		if (ind_max_fwd > 0)
			{
				ind_max_fwd -= 1;
			}

		else
			{
				ind_max_fwd = slide_fwd.length-1;
			}
			
		/* let next_slide = slide_fwd[ind_max_fwd];

		next_slide.style.display = "flex"; */

	for (let ind = 0; ind <= slide_fwd.length-1; ind++)
		{
			if ( ( (ind_min_fwd <= ind_max_fwd) && ((ind < ind_min_fwd) || (ind > ind_max_fwd)) ) || 
			( (ind_min_fwd > ind_max_fwd) && ( (ind_max_fwd < ind) && (ind < ind_min_fwd) ) ) )
				{
					slide_fwd[ind].style.display = "none";
				}
			else 
				{
					slide_fwd[ind].style.display = "flex";
					
					if ( (ind_min_fwd > ind_max_fwd) && (ind >= ind_min_fwd) )
						{
							slide_fwd[ind].style.order = "-1";
						}
					else
						{
							slide_fwd[ind].style.order = "0";
						}
				}
console.log(`style_slide_fwd[${ind}] = ` + slide_fwd[ind].style.display);
		}
console.log("ind_min_fwd = " + ind_min_fwd);
console.log("ind_max_fwd = " + ind_max_fwd);

		this[`ind_max_${langAcron}`] = ind_max_fwd;
		this[`ind_min_${langAcron}`] = ind_min_fwd;
	}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/* ******************************************** MOVING SLIDES FWD BY PUSH-IN/PUSH-OUT ********************************************  */

	pushFwd(langAcron) {
		
	let slide_fwd = this[`slides_${langAcron}`];
	let ind_DispSlide = this[`ind_slide_${langAcron}`];
	
	for (let ind=0; ind<slide_fwd.length; ind++)
		{
			let indSlide = slide_fwd[ind];
			
			if (ind_DispSlide===0)
				{
					indSlide.style.setProperty("transform",`translateX(${100*(ind_DispSlide + 1)-
					Math.min(Math.floor( (ind+2)/(slide_fwd.length - ind_DispSlide) ), 1)*slide_fwd.length*100}%)`);
				}
			else if (ind_DispSlide===1)
				{
					indSlide.style.setProperty("transform",`translateX(${100*(ind_DispSlide - 1)-
					Math.min(Math.floor( (ind+2)/(slide_fwd.length - ind_DispSlide + 2) ), 1)*slide_fwd.length*100}%)`);
				}
			else 
				{
					indSlide.style.setProperty("transform",`translateX(${100*(slide_fwd.length - ind_DispSlide + 1)-
					Math.min(Math.floor((ind+2)/ ind_DispSlide), 1)*slide_fwd.length*100}%)`);
				}
			indSlide.style.setProperty("visibility", "visible");
	//		indSlide.style.setProperty("border-style", "none");
	//		indSlide.style.setProperty("border-color", "none");
			indSlide.style.setProperty("transition-property", "transform");
			indSlide.style.setProperty("transition-duration", "0.9s");
			
				if ( (ind===ind_DispSlide-2) || ((ind_DispSlide===0) && (ind===slide_fwd.length-2)) || ((ind_DispSlide===1) && (ind===slide_fwd.length-1)) )
					{
					indSlide.style.setProperty("visibility", "hidden");
	//				indSlide.style.setProperty("border-style", "solid");
	//				indSlide.style.setProperty("border-color", "black");
					}
					
console.log(indSlide.style.getPropertyValue("transform"));
console.log(ind);
		}
//console.log(slide_fwd.length);
console.log(ind_DispSlide);
			
			if (ind_DispSlide===0)
			{
				ind_DispSlide = slide_fwd.length-1;
			}
			else
			{
				ind_DispSlide -= 1;
			}

		console.log(ind_DispSlide);
		
		this[`ind_slide_${langAcron}`] = ind_DispSlide;

		return ind_DispSlide;

}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


////////////////////////////////////// MOVE SLIDESHOW BWD ON CLICK EVENT ////////////////////////////////////////////////////
	moveBackOnClick(langAcron) {
console.log("langAcron = " + langAcron);		
		this[`ind_max_${langAcron}`] = -1;
		this[`ind_min_${langAcron}`] = -1;
		/* let ind_DispSlide = -1 */;
		
		let slides_Slideshow = this[`slides_${langAcron}`];
		
		var [ind_DispSlide, bBwd0Fwd1] = findHiddenPushedSlide(slides_Slideshow);
		
//console.log(ind_DispSlide);
//console.log(bBwd0Fwd1);

				if (ind_DispSlide !== -1)
				{
					if(bBwd0Fwd1===1)
						{
							if ( ind_DispSlide === 0)
								{
									ind_DispSlide = slides_Slideshow.length-1;
								}
							else 
								{
									ind_DispSlide -=1;
								}
						}
					else
						{
							if ( ind_DispSlide === slides_Slideshow.length-1 )
								{
								ind_DispSlide = 0;
								}
							else 
								{
								ind_DispSlide +=1;
								}
						}
console.log(ind_DispSlide);	
						
					this[`ind_slide_${langAcron}`] = ind_DispSlide;
					
					this.pushBwd(langAcron);
console.log(ind_DispSlide);	
				}
				else
				{
					this[`ind_min_${langAcron}`] = findDisplayedSlide(slides_Slideshow);
					this[`ind_max_${langAcron}`] = (this[`ind_min_${langAcron}`] + (this.numberOfSlides2Display - 1)) % slides_Slideshow.length;
		
					this.moveBack(langAcron);
console.log(`this[ind_min_${langAcron}] = ` + this[`ind_min_${langAcron}`]);	
console.log(`this[ind_max_${langAcron}] = ` + this[`ind_max_${langAcron}`]);	
				}

			if (this.slideShowZoomIn === true)
			{
				this.slidesZoomIn(langAcron);
			}
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


////////////////////////////////////// MOVE SLIDESHOW FWD ON CLICK EVENT ////////////////////////////////////////////////////
	moveFwdOnClick(langAcron) {
	
		this[`ind_max_${langAcron}`] = -1;
		this[`ind_min_${langAcron}`] = -1;
		/* let ind_DispSlide = -1; */
		
		let slides_Slideshow = this[`slides_${langAcron}`];
console.log("langAcron = " + `${langAcron}`);
console.log("slides = " + slides_Slideshow.length);
//console.log("slides = " + slides_Slideshow[0].outerHTML);
		
		var [ind_DispSlide, bBwd0Fwd1] = findHiddenPushedSlide(slides_Slideshow);
		
				if (ind_DispSlide !== -1)
				{
					if(bBwd0Fwd1===0)
						{
						if ( ind_DispSlide === slides_Slideshow.length-1 )
									{
									ind_DispSlide = 0;
									}
								else 
									{
									ind_DispSlide +=1;
									}
						}
					   else
						{
						if ( ind_DispSlide === 0 )
							{
								ind_DispSlide = slides_Slideshow.length - 1;
							}
						else 
							{
							ind_DispSlide -=1;
							}
						}
						
						this[`ind_slide_${langAcron}`] = ind_DispSlide;
					
					this.pushFwd(langAcron);
				}
				else
				{
					this[`ind_min_${langAcron}`] = findDisplayedSlide(slides_Slideshow);
					this[`ind_max_${langAcron}`] = (this[`ind_min_${langAcron}`] + (this.numberOfSlides2Display -1)) % slides_Slideshow.length;
					this.moveFwd(langAcron);
					
console.log(`this[ind_min_${langAcron}] = ` + this[`ind_min_${langAcron}`]);	
console.log(`this[ind_max_${langAcron}] = ` + this[`ind_max_${langAcron}`]);
				}	

				if (this.slideShowZoomIn === true)
				{
					this.slidesZoomIn(langAcron);
				}
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	darkerPrev(langAcron) {
	
		this[`buttonPrevDomEl_${langAcron}`].style.color = 
		"rgb(var(--pageAccessoriesColorRed), var(--pageAccessoriesColorGreen), var(--pageAccessoriesColorBlue))";
console.log(`this[buttonPrevDomEl_${langAcron}] = ` + this[`buttonPrevDomEl_${langAcron}`]);	
//console.log(`this[buttonPrevDomEl_${langAcron}] = ` + this[`buttonPrevDomEl_${langAcron}`].outerHTML);	
		this.mouseUpPrev = true;
}

	lighterPrev(langAcron) {
		
		this[`buttonPrevDomEl_${langAcron}`].style.color = "#811331";
			
		this.mouseDwnPrev = true;
}

	darkerNext(langAcron) {
	
		this[`buttonNextDomEl_${langAcron}`].style.color = 
		"rgb(var(--pageAccessoriesColorRed), var(--pageAccessoriesColorGreen), var(--pageAccessoriesColorBlue))";
				
		this.mouseUpNext = true;
}

	lighterNext(langAcron) {
		
		this[`buttonNextDomEl_${langAcron}`].style.color = "#811331";
			
		this.mouseDwnNext = true;
}
/* ******************************************** ZOOM-IN OF THE SLIDE BOXES ********************************************  */

	slidesZoomIn(langAcron) {
console.log(langAcron);
	var storedAvailableLang = localStorage.getItem("availableLang");
//console.log("storedAvailableLang = " + storedAvailableLang);
	var availableLang_a = JSON.parse(storedAvailableLang);
	
	var unselLangAcron;
	availableLang_a.forEach( (lang) => {
		let [avlbLangAcron, avlbLangInd] = getLangProperties(lang);
		
		if (avlbLangAcron !== langAcron)
		{
			unselLangAcron = avlbLangAcron;
		}
	})
console.log("unselLangAcron = " + unselLangAcron);

	let headDiv = document.getElementsByTagName("head")[0];
	
	if (window.matchMedia("(orientation: portrait)").matches)
		{
			if ( this.createdStyle4SlideZoomIn === false )
			{
				this.styleDomEl = document.createElement("style");
				headDiv.appendChild(this.styleDomEl);
				
				let activeSlideShowClass = this.slideShowDomEl.getAttribute('class');
				let activeSlideShowClassCSS = activeSlideShowClass.replace(/\s+/g, '.');
		
				this.styleDomEl.innerHTML = `
					.${activeSlideShowClassCSS} > .slideShow_lang_${langAcron} {
					transform: scale(1.4);
					transform-origin: 0% 100%;
					transition-property: transform;
					transition-duration: 3s;
				}
					.${activeSlideShowClassCSS} > .slideShow_lang_${unselLangAcron} {
					transform: scale(0.0);
					transform-origin: 100% 100%;
					transition-property: transform;
					transition-duration: 3s;
				}\n`
console.log(this.styleDomEl.innerHTML);
		this.createdStyle4SlideZoomIn = true;
			}
		}
	else 
		{
			if ( this.createdStyle4SlideZoomIn === true)
				{
				this.styleDomEl.remove();
				this.createdStyle4SlideZoomIn = false;
				}
//console.log(this.styleDomEl?.innerHTML);
		}
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// START THE SLIDESHOW ANIMATION
	startSlideShowAnim(langAcron) {
		
		// the scaling up of the review box size is reset when the slide-show is restarted
		if (this.createdStyle4SlideZoomIn === true)
				{
					this.styleDomEl.remove(); 
					this.createdStyle4SlideZoomIn = false;
				}
		
		const MoveFwd_Anim = (langAcron) => {
			
			if (this.mouseDwnPrev === true || this.mouseDwnNext === true)
				{ 
				clearInterval(this.slideShowAnimInterval); 
				}
			else 
				{
				if (this.slidesType_bPush1Fade0)
					{
					this.pushFwd(langAcron);
		//			this.pushBwd(langAcron);

console.log(`this[ind_slide_${langAcron}] = ` + this[`ind_slide_${langAcron}`]);
					}
				else 
					{
					this.moveFwd(langAcron);

console.log(`this[ind_min_${langAcron}] = ` + this[`ind_min_${langAcron}`]);
console.log(`this[ind_max_${langAcron}] = ` + this[`ind_max_${langAcron}`]);
					}
				}
		}
		
		this.slideShowAnimInterval = setInterval( ()=> {
		MoveFwd_Anim(langAcron)}, 
		3000);
		
	}

	
	init(langAcron) {

		this.mouseDwnPrev = false;
		this.mouseDwnNext = false;
		this.mouseUpPrev = false;
		this.mouseUpNext = false;
		
		let slides = this[`slides_${langAcron}`];
		
		if (this.slidesType_bPush1Fade0)
			{
				if (slides.length !== 0)
					{
						this.initPushSlideShow(langAcron);
					}
			}
			
			else 
				{
					if (slides.length !== 0)
						{
							this.initFadeSlideShow(langAcron);
						}
				}
		if (this.slidesAutoPlay === true)
		{
			this.startSlideShowAnim(langAcron);
		}
		
	}
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////// FUNCTIONS DEFINITIONS //////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function getLangProperties(language) {
	if (language === 'italian')
		{
			langAcron = 'it';
			langInd = 0;
		}
	else if (language === 'english')
		{
			langAcron = 'en';
			langInd = 1;
		}
	else if (language === 'french')
		{
			langAcron = 'fr';
			langInd = 2;
		}
	else if (language === 'german')
		{
			langAcron = 'de';
			langInd = 3;
		}
	else
	{
		langAcron = 'it';
		langInd = 0;
	}
	
	return [langAcron, langInd]
}

/* ******************************************** FIND THE CURRENTLY HIDDEN SLIDE ELEMENT (ONLY FOR PUSH-IN/PUSH-OUT SLIDESHOWS) ******************************  */

function findHiddenPushedSlide(slides) {
console.log(slides.length);
	let ind_hidden = -1;
	let ind_DispSlide = -1;
	let bBwd0Fwd1 = 0;
		
	for ( let i = 0; i <= slides.length - 1; i++ )
		{
//			if ( window.getComputedStyle(slides[i]).getPropertyValue("border-style") === "solid" )
			if ( window.getComputedStyle(slides[i]).getPropertyValue("visibility") === "hidden" )
				{
				ind_hidden = i;
				
				if ( window.getComputedStyle(slides[ind_hidden]).getPropertyValue("transition-duration") === "1s" )
					{
						bBwd0Fwd1 = 0;
						
						if ( ind_hidden === slides.length - 1 )
							{
								ind_DispSlide = 0;
							}
						else 
							{
								ind_DispSlide = ind_hidden + 1;
							}
					}
				else
					{	
						bBwd0Fwd1 = 1;
						
						if ( ind_hidden === slides.length-2 )
							{
								ind_DispSlide = 0;
							}
						else if ( ind_hidden === slides.length-1 )
						{
							ind_DispSlide = 1;
						}
						else 
							{
							ind_DispSlide = ind_hidden + 2;
							}
					}
//console.log(ind_DispSlide);
//console.log(bBwd0Fwd1);
//console.log(window.getComputedStyle(slides[ind_hidden]).getPropertyValue("transition-duration") === "1s"); 
//console.log(window.getComputedStyle(slides[ind_hidden]).getPropertyValue("border-style") === "solid");
				}
//console.log(window.getComputedStyle(slides[i]));			
		}
console.log("ind_hidden = " + ind_hidden);
//console.log(window.getComputedStyle(slides[ind_hidden]));

//console.log(slides.length);

	return [ind_DispSlide, bBwd0Fwd1];

}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/* ******************************************** FIND THE CURRENTLY DISPLAYED SLIDE ELEMENT ******************************  */

function findDisplayedSlide(slides) {
		
	let ind_min = -1;
		
	for (let i = 0; i <= slides.length - 1; i += 1)
		{ 
		if ( i === 0 )
		{
			if ((window.getComputedStyle(slides[i]).getPropertyValue("display") === "flex") && 
			(window.getComputedStyle(slides[slides.length - 1]).getPropertyValue("display") === "none"))
				{
				ind_min = i;
				}
		}
		else
			{
			if ((window.getComputedStyle(slides[i]).getPropertyValue("display") === "flex") && 
			(window.getComputedStyle(slides[i-1]).getPropertyValue("display") === "none"))
				{
				ind_min = i;
				}
			}
console.log(`style_slide[${i}] = ` + window.getComputedStyle(slides[i]).getPropertyValue("display"));
		}

//		ind_max = ind_min;
		
console.log("ind_min = " + ind_min);

	return ind_min;

}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////